// eslint-disable-next-line no-restricted-imports
import {
  OperationGetListQueryVariables,
  QueryInput_OperationController_GetList_OrderStatuses_Items as OrderStatusTypeApi,
} from 'api/generated/graphql';
import { OperationsFilterParams } from 'api/types/data/operation';
import { formatToISODate, lodash } from 'helpers';

type Result = Pick<
  OperationGetListQueryVariables,
  'orderStatuses' | 'orderEndDates' | 'executionDates' | 'traderIds' | 'search'
>;

export const parseOperationFiltersParam = (
  filter?: OperationsFilterParams
): Result => ({
  orderStatuses: filter?.orderStatuses?.length
    ? lodash.compact(
        filter.orderStatuses.map((status) => OrderStatusTypeApi[status])
      )
    : undefined,
  traderIds: filter?.traderIds,
  executionDates: filter?.executionTimestamps?.length
    ? filter.executionTimestamps.map((timestamp) =>
        formatToISODate(new Date(timestamp))
      )
    : undefined,
  orderEndDates: filter?.orderEndTimestamps?.length
    ? filter.orderEndTimestamps.map((timestamp) =>
        formatToISODate(new Date(timestamp))
      )
    : undefined,
  search: filter?.search || undefined,
});
